const FACEBOOK_OAUTH_URL = '/facebook/oauth';

export const redirectToFacebookOAuth = (isEmbedded: boolean) => {
    if (isEmbedded) {
        window.open(FACEBOOK_OAUTH_URL, '_blank', 'noopener,noreferrer');
    } else {
        window.location.href = FACEBOOK_OAUTH_URL;
    }
};
